import { createApp } from 'vue'
import App from './App.vue'
import axios from "axios";
/*
    Font awesome CSS
*/
import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
/*
Bootstrap CSS
*/
//import "../node_modules/bootstrap/dist/css/bootstrap.css";
//import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import store from './store'
import router from './router'
import { FocusTrap } from 'focus-trap-vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/css/theme.css'
import './assets/css/tables.css'


//import './index.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Add axios interceptors to add appId, userId, username to all requests except login
axios.interceptors.request.use(
  (config) => {
    // Skip interceptor for login and related pre-login requests
    if (
      config.url.includes("/Login") || 
      config.url.includes("Modules/getMachines") || 
      config.url.includes("ThemeImages/getThemeImage")
    ) {
      return config;
    }

    // Add appId, userId, username from localStorage to request data
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        appId: localStorage.appId,
        userId: localStorage.userId,
        username: localStorage.username
      };
    } else if (config.method === 'get') {
      config.params = {
        ...config.params,
        appId: localStorage.appId,
        userId: localStorage.userId,
        username: localStorage.username
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//createApp(App).use(router).use(store).use(store).use(store).use(store).mount('#app')
createApp(App).component('VueDatePicker', VueDatePicker).component('FocusTrap', FocusTrap).use(VueSweetalert2).use(router).use(store).mount('#app');
//const app = Vue.createApp({})
//App.config.globalProperties.$myGlobalVariable = "My app"